import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useEmpresa } from '@/components/hooks/useEmpresa';

export function useOnboardingProgress(id_empresa: string) {
  const location = useLocation();
  const { empresa, refetchEmpresa, loadingEmpresa } = useEmpresa(id_empresa);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handler = () => refetchEmpresa();
    const eventos = [
      'horario-guardado',
      'logo-guardado',
      'fotos-actualizadas',
      'descripcion-guardada',
      'servicios-actualizados',
      'trabajadores-actualizados',
    ];
    eventos.forEach((e) => window.addEventListener(e, handler));
    return () =>
      eventos.forEach((e) => window.removeEventListener(e, handler));
  }, [refetchEmpresa]);

  const isDashboard =
    location.pathname.includes('dashboard') ||
    location.pathname.endsWith('/panel-empresa');

  const pasos = empresa
    ? [
        !!empresa?.logo,
        !!empresa?.descripcion,
        Array.isArray(empresa?.horario_empresa) &&
          empresa.horario_empresa.length > 0,
        Array.isArray(empresa?.fotos) &&
          empresa.fotos.some((f) => f.destacado),
        Array.isArray(empresa?.servicios) && empresa.servicios.length > 0,
        Array.isArray(empresa?.trabajadores) &&
          empresa.trabajadores.length > 0,
      ]
    : [];

  const completados = pasos.filter(Boolean).length;
  const total = pasos.length;
  const porcentaje = total ? Math.round((completados / total) * 100) : 0;

  const visible =
    !isDashboard &&
    !dismissed &&
    !loadingEmpresa &&
    !!empresa &&
    completados < total;

  return { visible, completados, total, porcentaje, dismissed, setDismissed };
}